import { NumberField, NumberFieldProps, Group, Button, Input, Label } from 'react-aria-components';

import { Decrease } from './components/decrease';
import { Increase } from './components/increase';
import styles from './number-input.module.css';

export type NumberInputProps = Pick<
  NumberFieldProps,
  'value' | 'defaultValue' | 'minValue' | 'maxValue' | 'onChange' | 'id' | 'aria-labelledby'
> & {
  label?: string;
};

export const NumberInput = ({ label, ...props }: NumberInputProps) => {
  return (
    <NumberField
      formatOptions={{
        maximumFractionDigits: 0,
      }}
      {...props}
    >
      {label && <Label>{label}</Label>}

      <Group className={styles.numberInput}>
        <Button slot="decrement" className={styles.decrement}>
          <Decrease />
        </Button>

        <Input className={styles.input} />

        <Button slot="increment" className={styles.increment}>
          <Increase />
        </Button>
      </Group>
    </NumberField>
  );
};
